<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>Credits System Page</h2>

</div>
